module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_video.3aadd.png";